import { render, staticRenderFns } from "./AdminSettingsSharingForm.vue?vue&type=template&id=dc48382a&scoped=true"
import script from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettingsSharingForm.vue?vue&type=style&index=0&id=dc48382a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc48382a",
  null
  
)

export default component.exports